import metadata from '@/data/metadata';

type Menu = {
  name: string;
  href: string;
  external: boolean;
};

const menu: Menu[] = [
  {
    name: "About",
    href: "#about",
    external: false,
  },
  {
    name: "Spotlight",
    href: "#spotlight",
    external: false,
  },
  {
    name: "Portfolio",
    href: "#portfolio",
    external: false,
  },
  {
    name: "Experience",
    href: "#experience",
    external: false,
  },
  {
    name: "Education",
    href: "#education",
    external: false,
  },
  {
    name: "Blog",
    href: metadata.social.blog,
    external: true,
  },
];

export default menu;